var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "file-edit"
  }, [_c('style-bar', {
    staticClass: "mb-2",
    attrs: {
      "css-keys": ['background', 'color'],
      "mode": "text",
      "styles": _vm.localStyles
    },
    on: {
      "update:styles": function updateStyles($event) {
        _vm.localStyles = $event;
      }
    }
  }), _c('v-text-field', {
    staticClass: "text-field mt-2 pt-5 px-2",
    attrs: {
      "hide-details": "",
      "placeholder": "Download PDF",
      "label": _vm.$t('file_text')
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  }), _c('rich-text-input', {
    ref: "urlInput",
    staticClass: "py-2 px-2",
    attrs: {
      "placeholder": "https://www.example.com/file.pdf",
      "content": _vm.form.url,
      "mode": "url",
      "json": _vm.editorContentJson,
      "label": _vm.$t('file_link')
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.form, "url", $event);
      },
      "update:json": function updateJson($event) {
        _vm.editorContentJson = $event;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }